module.exports = __webpack_public_path__ + "static/media/childlabor.d9c9c4d1.jpg";